import React from 'react';
import PropTypes from 'prop-types';

export const Tier = ({ title, price, renderInfo, children }) => {
  return (
    <div className="tier">
      <div className="tier__content">
        <div className="tier__subtitle">WeTransfer Plus</div>
        <h3 className="tier__title">{title}</h3>
        <div className="tier__price">
          <span>${price}</span>
          <sup>USD</sup> <span className="tier__period">/ month</span>
        </div>
        <div className="tier__info">{renderInfo()}</div>
      </div>
      {children}
    </div>
  );
};

Tier.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  renderInfo: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default React.memo(Tier);
